import React from "react";
import { logout } from "../../../components/Siderbar";

const Logout = () => {
  logout();
  return <div></div>;
};

export default Logout;
